import React, { useContext, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, TextField, Button } from "@material-ui/core";

// Contexts
import CampaignContext from "../../../context/campaign/CampaignContext";

const useStyles = makeStyles(() => ({
  section: {
    marginTop: "0.1rem",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const Section_01 = () => {
  const classes = useStyles();

  const { lander_url, setLanderUrl, importLander, form_data } =
    useContext(CampaignContext);

  const [url_error, setUrlError] = useState("");
  const [button_disabled, setButtonDisabled] = useState(true);

  const handleChange = (e) => {
    const value = e.target.value;
    let error =
      "Please insert a valid url! (E.g. https://techie-gadget-shop.myshopify.com/admin/pages/79643476004)";

    if (value.length > 0) {
      if (value.includes("https://")) {
        const page_index = new URL(value).pathname.split("/").pop();

        // Remove Error Message If URL Valid
        if (!isNaN(parseInt(page_index))) error = "";
      }
    }

    setLanderUrl(value.trim());
    setUrlError(error);
  };

  useEffect(() => {
    // Update "Import" Button Status
    if (lander_url && !url_error) setButtonDisabled(false);
    else setButtonDisabled(true);
  }, [lander_url, url_error, form_data]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="caption" color="primary">
          Step 1: Import Lander
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        spacing={2}
        container
        alignItems="flex-start"
        justifyContent="flex-start"
        className={classes.section}
      >
        <Grid item xs>
          <TextField
            required
            fullWidth
            size="small"
            variant="outlined"
            id="lander_url"
            name="lander_url"
            onChange={handleChange}
            value={lander_url ? lander_url : ""}
            error={url_error && !form_data.handle ? true : false}
            helperText={url_error}
          />
        </Grid>
        <Grid item xs={2} container spacing={1}>
          <Grid item className={classes.buttonBox}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              disabled={button_disabled}
              onClick={importLander}
            >
              Import
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Section_01;
